export const DEFAULT_CHART_COLORS = {
  0: {
    bg: 'rgba(255, 99, 132, 0.5)',
    bc: 'rgba(255, 99, 132, 1)',
  },
  1: {
    bg: 'rgba(75, 192, 192, 0.5)',
    bc: 'rgba(75, 192, 192, 1)',
  },
  2: {
    bg: 'rgba(255, 251, 21, 0.5)',
    bc: 'rgba(255, 251, 21, 1)',
  },
  3: {
    bg: 'rgba(255, 166, 0, 0.5)',
    bc: 'rgba(255, 166, 0, 1)',
  },
  4: {
    bg: 'rgba(127,255,212, 0.5)',
    bc: 'rgba(127,255,212, 1)',
  },
  5: {
    bg: 'rgba(131,111,255, 0.5)',
    bc: 'rgba(131,111,255, 1)',
  },
  6: {
    bg: 'rgba(0,255,0, 0.5)',
    bc: 'rgba(0,255,0, 1)',
  },
  7: {
    bg: 'rgba(220,20,60, 0.5)',
    bc: 'rgba(220,20,60, 1)',
  },
  8: {
    bg: 'rgba(0,250,154, 0.5)',
    bc: 'rgba(0,250,154, 1)',
  },
  9: {
    bg: 'rgba(233,150,122, 0.5)',
    bc: 'rgba(233,150,122, 1)',
  },
}
